<template>
  <body>
    <component :is="componentName" />
  </body>
</template>

<script>
import Vue from 'vue'
import StyleInjector from './StyleInjector'
import 'bootstrap'
import { default as cssUtils } from 'css'

Vue.component('style-injector', StyleInjector)

export default {
  name: 'StaticHtmlRender',
  props: {
    html: String,
    css: {
      type: String,
      default: '',
    },
  },
  data() {
    const componentName = this.makeId(10)
    this.createComponent(componentName, '<div></div>')
    return {
      componentName: componentName,
    }
  },
  methods: {
    createComponent(name, html, css) {
      var finalTemplate = ""
      if (css != null && css.length > 0) {
        const uuid = this.makeId(10)
        const cssObj = cssUtils.parse(css)
        if (cssObj.stylesheet) {
          this.appendNamespaceForSelectors(cssObj.stylesheet.rules, '[' + uuid + '] ')
        }
        const scopedStyle = cssUtils.stringify(cssObj)
        finalTemplate = '<div ' + uuid + '><style-injector app-style=\'' + scopedStyle + '\'></style-injector>' + html + '</div>'
      } else {
        finalTemplate = '<div>' + html + '</div>'
      }
      Vue.component(name, {
        template: finalTemplate,
      })
    },
    makeId(length) {
      const characters= 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
      const charactersLength = characters.length
      var result = ''
      for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result;
    },
    appendNamespaceForSelectors(rules, namespace) {
      for (var i = 0; i < rules.length; i++) {
        const rule = rules[i]
        if (rule.selectors) {
          for (var j = 0; j < rule.selectors.length; j++) {
            rule.selectors[j] = namespace + ' ' +  rule.selectors[j]
          }
        } else if (rule.rules) {
          this.appendNamespaceForSelectors(rule.rules, namespace)
        }
      }
    },
  },
  mounted () {
    const componentName = this.makeId(10)
    this.createComponent(componentName, this.html, this.css)
    this.componentName = componentName
  },
}
</script>